<template>
  <v-main>
    <v-app-bar app dark color="primary" elevation="4">
      <v-img class="mx-5" contain src="../assets/S-white.png" max-width="40"></v-img>
      <v-app-bar-title> SIC Support Files </v-app-bar-title>
      <p>{{ username }}</p>
      <v-btn icon @click="logout">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
      <template v-slot:extension>
        <v-tabs v-model="tab">
          <v-tab value="docs">Documents</v-tab>
          <v-tab value="sdks">Supported Tools</v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <p class="text-blue">*Some files may require an NDA and might not be visible. If you cannot find what you
      are looking for, please contact your sales representative or email us at info@sic.co.th.</p>
    <v-window v-model="tab">
      <v-window-item value="docs">
        <files-table v-if="!isLoad"></files-table>
      </v-window-item>
      <v-window-item value="sdks">
        <sdks-table v-if="!isLoad"></sdks-table>
      </v-window-item>
    </v-window>
  </v-main>
</template>

<script>
import FilesTable from "../components/FilesTable.vue";
import SdksTable from "../components/SdksTable.vue";

export default {
  data: () => ({
    account: null,
    username: null,
    isLoad: true,
    tab: "",
  }),
  components: {
    FilesTable,
    SdksTable,
  },
  methods: {
    logout() {
      this.$store.dispatch("logout", {
        homeAccountId: this.account.UserId,
      });
    },
    async getFiles() {
      this.isLoad = true;

      try {
        await this.$store.dispatch("file/getFilesList");
        await this.$store.dispatch("sdk/getFilesList");
      } catch (err) {
        console.log(err);
      }

      this.isLoad = false;
    },
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    var fileType = urlParams.get("type");

    console.log(fileType)

    if (fileType == "sdk") {
      this.tab = "sdks";
    } else {
      this.tab = "docs"
    }
  },
  mounted() {
    this.account = this.$store.getters.account;
    console.log(this.account);
    this.username = this.account.Name;
    this.getFiles();
  },
};
</script>